import { render } from "./portalContentLayout.vue?vue&type=template&id=1d55330d&scoped=true"
import script from "./portalContentLayout.vue?vue&type=script&lang=js"
export * from "./portalContentLayout.vue?vue&type=script&lang=js"

import "./portalContentLayout.vue?vue&type=style&index=0&id=1d55330d&scoped=true&lang=css"
import "./portalContentLayout.vue?vue&type=style&index=1&id=1d55330d&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d55330d"]])

export default __exports__